import React, { useContext, useEffect, useState } from "react";
import Card from "components/Card";
// import { store } from "../../store.js";
import Analytics from "core/Utils/Analytics";
import { store } from "store.js";
import { setResetPasswordUrlRedirect } from "core/Utils/SetResetPasswordUrl";
import Loading from "components/Loading";

export default function Home() {
  const [isLoading, setIsLoading] = useState(false);
  const globalState = useContext(store);
  const { dispatch, state } = globalState;
  const { user } = state;
  
  useEffect(function () {
    Analytics().setVirtualPageView();
    dispatch({
      type: "SET_GA",
      payload: { currentFlow: "home" },
    });
  }, []);
  return (
    <>
      <Loading isLoading={isLoading} />
      <div>
        <div className="mdn-Row">
          <div className="mdn-Col-md-12">
            <h1 className="mdn-Heading mdn-Heading--lg">Bem vindo!</h1>
            <p className="mdn-Text mdn-Text--body mdn-u-marginTop--xxs">
              Aqui você pode ver quais números estão ativos no seu CPF, alterar ou
              atualizar seus dados já cadastrados.
            </p>
          </div>
        </div>
        <div className="mdn-Row">
          {/* <div className="mdn-Col-md-6 mdn-u-marginTop--md">
            <Card
              tabIndex="20"
              icon={"solar-ache-aqui"}
              title={"Meus números"}
              link={"meuperfil/meus-numeros"}
              text={
                "Visualize os seus números ativos no seu CPF e adicione um dependente."
              }
            />
          </div> */}
          <div className="mdn-Col-md-6 mdn-u-marginTop--md">
            <Card
              tabIndex="21"
              icon={"senha"}
              title={"Alterar senha"}
              link="#"
              onClick={() => {
                setIsLoading(true);
                setResetPasswordUrlRedirect(user);
                setTimeout(() => setIsLoading(false), 1000);
              }}
              text={"Altere sua senha e tenha acesso a todos os seus produtos."}
            />
          </div>
          <div className="mdn-Col-md-6 mdn-u-marginTop--md">
            <Card
              tabIndex="22"
              icon={"e-mail"}
              title={"Alterar e-mail"}
              link={"meuperfil/alterar-email"}
              text={"Mude seu e-mail de acesso de todos os produtos."}
            />
          </div>
          <div className="mdn-Col-md-6 mdn-u-marginTop--md">
            <Card
              tabIndex="23"
              icon={"celular"}
              title={"Acesso pelo celular"}
              link={"meuperfil/acesso-pelo-celular"}
              text={
                "Habilite um celular para realizar o acesso recebendo um código por SMS."
              }
            />
          </div>
        </div>
      </div>
    </>
  );
}
